export default "__VITE_ASSET__DR2266lv__"